import { render } from "./Arrow-icon.vue?vue&type=template&id=0d8d15fa"
import script from "./Arrow-icon.vue?vue&type=script&lang=js"
export * from "./Arrow-icon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__